export function createDragElement(item: { file: { fileName: string } }, event: React.DragEvent): void {
  const dragElement = document.createElement('div');
  dragElement.textContent = item.file.fileName;

  Object.assign(dragElement.style, {
    position: 'absolute',
    top: '-1000px',
    left: '-1000px',
    padding: '8px 16px',
    backgroundColor: '#ffffff',
    border: '1px solid #E5E5E5',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    fontSize: '14px',
    fontWeight: '500',
    color: '#333333',
    whiteSpace: 'nowrap',
    transform: 'rotate(5deg)',
    opacity: '0.9',
    pointerEvents: 'none',
    zIndex: '1000',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  });

  document.body.appendChild(dragElement);

  event.dataTransfer.setDragImage(
    dragElement,
    dragElement.offsetWidth / 2,
    dragElement.offsetHeight / 2,
  );

  setTimeout(() => {
    if (document.body.contains(dragElement)) {
      document.body.removeChild(dragElement);
    }
  }, 0);
}